<script setup lang="ts">
import SvgIcon from '@/components/base/SvgIcon.vue';
import { env } from '@/env';

const providers = [
  {
    id: 1,
    name: 'Google',
    icon: 'google',
    color: 'google-500',
    bgColor: 'white'
  },
  {
    id: 2,
    name: 'Facebook',
    icon: 'facebook',
    color: 'facebook-500',
    bgColor: 'white'
  },
  { id: 3, name: 'LINE', icon: 'line', color: 'line-500', bgColor: 'white' },
  { id: 4, name: 'Apple', icon: 'apple', color: 'gray-900', bgColor: 'white' }
];

const route = useRoute();

const handleClick = () => {
  const provider = providers.find((x) => x.id === 4);
  sessionStorage.setItem('thirdPartySigUp', 'Apple');

  if (provider) {
    const frontendUrl = encodeURIComponent(`${window.location.origin}/login`);
    const redirectUrl = encodeURIComponent(
      `${window.location.origin}/auth/${provider.name}/register`
    );

    //VITE_AUTH_ENV = 8 localhost
    window.location.href = `${import.meta.env.VITE_AUTH_API_URL}/oauth/${provider.name}/init?clientId=${
      import.meta.env.VITE_AUTH_CLIENT_ID
    }&environmentId=${import.meta.env.VITE_AUTH_ENV}&frontendUrl=${frontendUrl}`;
  }
};

onMounted(() => {
  const { sub, email } = route.query;

  localStorage.setItem('from-third-party-type', '4');
  if (!Array.isArray(sub)) localStorage.setItem('from-third-party-id', sub ?? '');
  if (!Array.isArray(email)) localStorage.setItem('from-third-party-email', email ?? '');
});
</script>

<template>
  <div class="line-third-card" @click="handleClick">
    <SvgIcon name="apple" style="width: 32px; height: 32px" class="md" />
  </div>
</template>

<style lang="scss" scoped>
/** style */
.line-third-card {
  cursor: pointer;
}
</style>
